import { api } from '@/lib/api'
import type { APIResponse } from '@/types/api'
import type { User } from '@/types/user'

export interface CreateUserData {
	companyID: string
	code: string
	name: string
	email: string
	password: string
	role: 'manager' | 'employee'
}

export interface UpdateUserData {
	id: string
	companyID: string
	code?: string
	name?: string
	email?: string
	password?: string
	role?: 'manager' | 'employee'
}

/**
 * Servicio para gestionar usuarios
 */

export class UsersService {
	/**
	 * Obtiene todos los usuarios de una empresa
	 */
	static async getUsers(companyID: string | undefined = undefined): Promise<User[]> {
		const response = await api.get<APIResponse<User[]>>(`/users`, {
			params: companyID ? { companyID } : undefined,
		})
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al obtener usuarios')
		}

		return apiResponse.data
	}

	/**
	 * Crea un nuevo usuario
	 */
	static async createUser(data: CreateUserData): Promise<User> {
		const response = await api.post<APIResponse<User>>(`/users`, data)
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al crear usuario')
		}

		return apiResponse.data
	}

	/**
	 * Actualiza un usuario
	 */
	static async updateUser(data: UpdateUserData): Promise<User> {
		const response = await api.put<APIResponse<User>>(`/users`, { ...data })
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al actualizar usuario')
		}

		return apiResponse.data
	}

	/**
	 * Elimina un usuario
	 */
	static async deleteUser(userId: string): Promise<void> {
		const response = await api.delete<APIResponse<void>>(`/users?id=${userId}`)
		const apiResponse = response.data

		if (!apiResponse.success) {
			throw new Error(apiResponse.message || 'Error al eliminar usuario')
		}
	}
}
